'use client';

import * as DS from '@aurorasolar/ds';
import { ReactNode } from 'react';

type Props = { children: ReactNode };

export const NumberedStep = ({ children }: Props) => (
  <DS.Box bg="uiButtonCta.defaultBgColor" px={4} py={1} w="fit-content">
    <DS.Text as="span" color="black" text="d1">
      {children}
    </DS.Text>
  </DS.Box>
);
